import { highlightSelectedStyle } from '@constants/constants';
import { WidgetProps } from '@modules/reports/components/WidgetWrap';
import SendIcon from '@mui/icons-material/Send';
import { Box } from '@mui/material';

import SendNotificationModal from '@src/modules/notifications/components/SendNotificationModal';
import { SettingsSizeOptions } from '@utils/constants/selectOptions';

import { useApolloClient } from '@apollo/client';
import { GET_DATA_SUBSCRIPTION } from '@graphql/queries';
import useColors from '@utils/useColors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// eslint-disable-next-line @typescript-eslint/naming-convention
const W_ReactionButton = (props: WidgetProps) => {
  const { object, selected, ...widgetEditControlsProps } = props;
  const client = useApolloClient();

  const getPropValue = (prop: string): string | number | null =>
    object.objectProperties.find((obj) => obj.key === prop)?.value;

  const { getColorBasedOnStyle } = useColors();

  const style: any = getPropValue('settingsStyle');
  const size: any = getPropValue('settingsSize');
  const [settingsObject, setSettingsObject] = useState(getPropValue('settingsObject') || ('' as string));
  const [settingsTags, setSettingsTags] = useState(getPropValue('settingsTags') || []);
  const [settingsActionName, setSettingsActionName]: any = useState(getPropValue('settingsActionName'));
  const [{ fg: fgColor, bg: bgColor }, setColors] = useState(getColorBasedOnStyle(style));

  useEffect(() => {
    const observer = client.subscribe({
      query: GET_DATA_SUBSCRIPTION,
      variables: { objId: props.object.id },
    });

    const subscription = observer.subscribe(({ data }) => {
      if (data.Objects.relatedNode?.key === 'settingsObject') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setSettingsObject(data.Objects.relatedNode?.value as string);
      } else if (data.Objects.relatedNode?.key === 'settingsActionName') {
        setSettingsActionName(data.Objects.relatedNode?.value);
      } else if (data.Objects.relatedNode?.key === 'settingsStyle') {
        setColors(getColorBasedOnStyle(data.Objects.relatedNode?.value));
      } else if (data.Objects.relatedNode?.key === 'settingsTags') {
        setSettingsTags(data.Objects.relatedNode?.value);
      }
    });
    return () => subscription.unsubscribe();
  }, [props.object.id]);

  const getValueFontSize = () => {
    if (size === SettingsSizeOptions.medium) {
      return '48px';
    }
    if (size === SettingsSizeOptions.small) {
      return '20px';
    }
    return '20px';
  };

  const isEditMode = useSelector((state: any) => state.settings.isEditMode);

  const handleClick = () => {
    if (settingsObject) {
      SendNotificationModal({
        tags: settingsTags as string[],
        object: {
          id: settingsObject,
          name: props.object.name,
        },
      }).then((r) => {});
    }
  };

  return (
    <div
      onClick={!isEditMode ? handleClick : undefined}
      style={{
        height: '100%',
        backgroundColor: bgColor,
        pointerEvents: isEditMode ? 'none' : 'auto',
        filter: selected ? highlightSelectedStyle : '',
      }}
    >
      <Box
        sx={{
          padding: '8px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: size === SettingsSizeOptions.small ? '8px' : '20px',
          color: fgColor,
          height: '100%',
        }}
      >
        <SendIcon
          sx={{
            width: size === SettingsSizeOptions.small ? '24px' : '50px',
            height: size === SettingsSizeOptions.small ? '24px' : '50px',
            color: fgColor,
          }}
        />
        {settingsActionName && (
          <Box
            sx={{
              fontWeight: '500',
              fontSize: getValueFontSize(),
            }}
          >
            {settingsActionName}
          </Box>
        )}
      </Box>
    </div>
  );
};

export default W_ReactionButton;
